import React from "react";
import { motion } from "framer-motion";

const style = {
    width: 8,
    height: 8,
    opacity: 1,
    margin: 4,
    borderRadius: '50%',
    display: "inline-block",
    background: "#e11d48", // Rose color to match your theme
}
  
const variants = {
    start: {
        scale: 0.3,
        opacity: 0.5,
    },
    end: {
        scale: 1,
        opacity: 1,
    },
}

const DotLoader = () => {
    return (
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            padding: '8px 0'
        }}>
          <motion.div
                    style={style}
                    variants={variants}
                    initial={"start"}
                    animate={"end"}
                    transition={{    
                      repeat: Infinity,
                      repeatType: "reverse",
                      ease: "easeInOut",
                      duration: 0.8, 
                      delay: 0
                    }}
                />
          <motion.div
                    style={style}
                    variants={variants}
                    initial={"start"}
                    animate={"end"}
                    transition={{    
                      repeat: Infinity,
                      repeatType: "reverse",
                      ease: "easeInOut",
                      duration: 0.8, 
                      delay: 0.2
                    }}
                />
          <motion.div
                    style={style}
                    variants={variants}
                    initial={"start"}
                    animate={"end"}
                    transition={{    
                      repeat: Infinity,
                      repeatType: "reverse",
                      ease: "easeInOut",
                      duration: 0.8, 
                      delay: 0.4
                    }}
                />    
        </div>
    )
}

export default DotLoader;